import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSave } from 'react-icons/fa';

interface RewardFormActionsProps {
  isLoading: boolean;
  isEditMode: boolean;
}

export const RewardFormActions: React.FC<RewardFormActionsProps> = ({ isLoading, isEditMode }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-end gap-4 p-4 border-t border-gray-200 mt-8">
      <button
        type="button"
        onClick={() => navigate('/rewards')}
        className="px-6 py-3 text-gray-600 font-medium hover:bg-gray-100 rounded-xl transition-colors"
      >
        Cancel
      </button>
      <button
        type="submit"
        disabled={isLoading}
        className={`px-8 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-medium rounded-xl shadow-lg transition-all flex items-center gap-2 ${
          isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:-translate-y-0.5 hover:shadow-xl'
        }`}
      >
        <FaSave />
        {isLoading ? (isEditMode ? 'Saving...' : 'Creating...') : (isEditMode ? 'Save Changes' : 'Create Reward')}
      </button>
    </div>
  );
};
